
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertController, IonInput, IonicModule } from '@ionic/angular';
import { IBeerStyle } from 'app/models/beerstyle';

@Component({
  selector: 'app-select-beerstyle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, FormsModule],
  templateUrl: './select-beerstyle.component.html',
  styleUrls: ['./select-beerstyle.component.scss'],
})
export class SelectBeerstyleComponent implements OnChanges {

  @Input() allBeerstyles!: IBeerStyle[];
  @Input() selected!: IBeerStyle | undefined;
  @Output() update = new EventEmitter<IBeerStyle>();
  @Output() deleteItem = new EventEmitter<string>();
  @Output() addItem = new EventEmitter<string>();

  beerstyles: IBeerStyle[] = [];
  isAddItem = false;
  newItemName: string = '';
  searchPhrase: string = '';
  isOpenSignal = signal(false);
  isOpen = false;
  //  selected!: IBeerStyle;

  constructor(private alertController: AlertController) { }



  ngOnChanges(changes: SimpleChanges) {
    if (changes['allBeerstyles']?.currentValue) {
      if (!!this.searchPhrase) {
        this.beerstyles = this.allBeerstyles.filter(x => x.name.toLowerCase().indexOf(this.searchPhrase.toLowerCase()) > -1)
      } else {
        this.beerstyles = [
          ...this.allBeerstyles
        ];

      }

    }
  }

  open() {
    this.isOpen = true;
    this.isOpenSignal.set(true);
    this.searchPhrase = '';
  }
  cancel() {
    this.isOpenSignal.set(false);
    this.isOpen = false;
    // this.searchPhrase = '';
    this.beerstyles = [...this.allBeerstyles];
  }
  cancelAddNew() {
   this.isAddItem = false;
  }
  select(item: IBeerStyle) {
    this.beerstyles = [...this.allBeerstyles];
    // this.searchPhrase = '';
    this.selected = item;
    this.update.emit(item);
    this.isOpen = false;
    this.isOpenSignal.set(false);

  }

  onWillDismiss(event: any): void {
    this.isOpen = false;
    this.isOpenSignal.set(false);

    this.beerstyles = [...this.allBeerstyles];
    // this.searchPhrase = '';
  }
  onWillDismissAddNew(event: any) {
    this.isAddItem = false;
    // this.searchPhrase = '';
  }

  trackBy(index: number, item: IBeerStyle) {
    return item.id;
  }

  onSearchChange(event: any) {
    this.searchPhrase = event.detail.value.toLowerCase();
    this.beerstyles = this.allBeerstyles.filter(x => x.name.toLowerCase().indexOf(this.searchPhrase.toLowerCase()) > -1)
  }

  addInternalItem(itemName: string) {
    this.searchPhrase = itemName;
    this.isAddItem = false;
    this.newItemName = '';
    this.addItem.emit(itemName);
  }

  openAddNewItem() {
    this.isAddItem = true;
    this.newItemName = this.searchPhrase;
  }

  async confirmDeleteBeerstyle(item: IBeerStyle) {
    const alert = await this.alertController.create({
      header: "Delete beer style",
      message: `Are you sure you want to delete ${item.name}?`,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: 'alert-button-cancel'
        },
        {
          text: "Delete",
          cssClass: 'alert-button-delete',
          handler: () => {
            this.deleteItem.emit(item.id);
          },
        },
      ],
    });

    await alert.present();
  }
}


